import React, { useState, useEffect } from "react";

const EditProfile = () => {
  const [formData, setFormData] = useState({
    userId: "",
    name: "",
    email: "",
  });

  useEffect(() => {
    // ✅ Load values from localStorage
    setFormData({
      userId: localStorage.getItem("userId") || "",
      name: localStorage.getItem("name") || "",
      email: localStorage.getItem("email") || "",
    });
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSave = (e) => {
    e.preventDefault();
    // ✅ Save updated values into localStorage
    localStorage.setItem("userId", formData.userId);
    localStorage.setItem("name", formData.name);
    localStorage.setItem("email", formData.email);

    alert("Profile updated successfully!");
    window.location.href = "/profile"; // redirect to profile page
  };

  return (
    <section className="py-5" style={{ background: "#f8fff8" }}>
      <div className="container">
        <div className="card shadow-lg border-0 rounded-4 p-4">
          <h3 className="fw-bold text-success mb-4">Edit Profile</h3>
          <form onSubmit={handleSave}>
            <div className="row g-3">
              <div className="col-md-6">
                <label className="form-label fw-bold">User ID</label>
                <input
                  type="text"
                  name="userId"
                  className="form-control"
                  value={formData.userId}
                  onChange={handleChange}
                  readOnly // ✅ usually userId should not be editable
                />
              </div>
              <div className="col-md-6">
                <label className="form-label fw-bold">Email</label>
                <input
                  type="email"
                  name="email"
                  className="form-control"
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-12">
                <label className="form-label fw-bold">Full Name</label>
                <input
                  type="text"
                  name="name"
                  className="form-control"
                  value={formData.name}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="mt-4 text-end">
              <button type="submit" className="btn btn-success px-4">
                Save Changes
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default EditProfile;
